import type { ReactNode } from 'react'
import { StyleSheet } from 'react-native'
import { Card } from 'react-native-paper'
import { Link } from '@/ui/Link'

interface CardLinkProps {
    href: string
    children: ReactNode
    minHeight?: number
    accessibilityLabel?: string
}

export function CardLink({ href, children, minHeight = 96, accessibilityLabel }: CardLinkProps) {
    return (
        <Link href={href}>
            <Card
                style={[styles.card, { minHeight: minHeight }]}
                accessibilityLabel={accessibilityLabel}
            >
                {children}
            </Card>
        </Link>
    )
}

const styles = StyleSheet.create({
    card: {
        margin: 0,
        padding: 16,
    },
})
